import { useEffect, useRef, useState } from "react";
import "./SectionSeparator.css";

export default function SectionSeparator() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.4 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`sep-wrapper ${visible ? "sep-wrapper--visible" : ""}`} ref={ref}>
      {/* Left line */}
      <div className="sep-line sep-line--left" />

      {/* Center ornament */}
      <div className="sep-ornament">
        <div className="sep-diamond" />
        <div className="sep-dot" />
        <div className="sep-diamond sep-diamond--sm" />
        <div className="sep-dot" />
        <div className="sep-diamond" />
      </div>

      {/* Right line */}
      <div className="sep-line sep-line--right" />
    </div>
  );
}
